























import {Component, Prop, Vue} from 'vue-property-decorator'
import {ExplorerCollection} from '@/model/collection/ExplorerCollection'
import {FilterExplorerSchema} from '@/schema/resource/Explorer/FilterExplorerSchema'
import FilterExplorerFiltered from '@/components/filters/FilterExplorerFiltered.vue'

@Component({
  components: {
    FilterExplorerFiltered,
  },
})
export default class FilterExplorer extends Vue {
  @Prop({type: Object, required: true}) collection!: ExplorerCollection

  schema = new FilterExplorerSchema()

  async created() {
    await this.populateFilterOptions()
  }

  async populateFilterOptions() {
    this.collection.resource = this.schema

    const promises: Array<Promise<any>> = [
      this.collection.resource.collectionBlockchainVersion.queryAsPage(),
    ]

    await this.$await.run('softQuery', () => Promise.all(promises))
  }

  async doFilter() {
    this.$emit('submit')
    await this.$await.run('softQuery', () => this.collection.queryToFirstPage())
  }

  doClear() {
    this.collection.explorerBlockchainVersion = []
    this.doFilter()
  }
}
